import { render, staticRenderFns } from "./PageAccessMochiIdLink.vue?vue&type=template&id=6e07b372&scoped=true&"
import script from "./PageAccessMochiIdLink.vue?vue&type=script&lang=js&"
export * from "./PageAccessMochiIdLink.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessMochiIdLink.vue?vue&type=style&index=0&id=6e07b372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07b372",
  null
  
)

export default component.exports